export default __webpack_public_path__ + "static/media/chantilly9.6e2689e6.jpg";